import { render, staticRenderFns } from "./EquipmentContrast.vue?vue&type=template&id=2b7f8dfe&scoped=true"
import script from "./EquipmentContrast.vue?vue&type=script&lang=js"
export * from "./EquipmentContrast.vue?vue&type=script&lang=js"
import style0 from "./EquipmentContrast.vue?vue&type=style&index=0&id=2b7f8dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f8dfe",
  null
  
)

export default component.exports